import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IHospitalResult } from '../../../models/hospital/HospitalModel';
import HospitalManagementActionCell from './parts/HospitalManagementActionCell';
import styles from './HospitalManagement.module.css';

/**
 * Provides column definitions for the Hospital Management ODataGrid.
 */
export function useHospitalManagementColumns(): ODataGridColumn<IHospitalResult>[] {
  return useMemo<ODataGridColumn<IHospitalResult>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 160,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <HospitalManagementActionCell row={row} />,
      },
      {
        field: 'id',
        header: 'ID',
        dataType: 'numeric',
        width: 80,
        sortable: true,
        filter: true,
      },
      {
        field: 'hospitalName',
        header: 'Hastane Adı',
        minWidth: 125,
        sortable: true,
        filter: true,
      },
      {
        field: 'createdDate',
        header: 'Oluşturulma Tarihi',
        dataType: 'date',
        minWidth: 125,
        sortable: true,
        filter: true,
        body: row =>
          row.createdDate ? new Date(row.createdDate).toLocaleString('tr-TR') : '',
      },
      {
        field: 'isHospitalClosed',
        header: 'Hastane Kapalı',
        dataType: 'boolean',
        width: 120,
        sortable: true,
        filter: true,
        body: row => {
          if (row.isHospitalClosed === null || row.isHospitalClosed === undefined) {
            return '-';
          }
          const label = row.isHospitalClosed ? 'Evet' : 'Hayır';
          const statusClass = row.isHospitalClosed ? styles.closedYes : styles.closedNo;
          return <span className={statusClass}>{label}</span>;
        },
      },
      {
        field: 'recordCount',
        header: 'Kayıt Sayısı',
        dataType: 'numeric',
        width: 120,
        sortable: true,
        filter: true,
        body: row => (
          <span className={styles.recordCountCell}>
            {row.recordCount ?? 0}
          </span>
        ),
      },
      {
        field: 'hospitalCloseDate',
        header: 'Kapanış Tarihi',
        dataType: 'date',
        minWidth: 150,
        sortable: true,
        filter: true,
        body: row =>
          row.hospitalCloseDate
            ? new Date(row.hospitalCloseDate).toLocaleDateString('tr-TR')
            : '-',
      },
    ],
    []
  );
}
